import {
  Autocomplete,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import InputMask from "react-input-mask";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { validarFormatacaoDocumento } from "../../../services/validation.service";

const ResponsavelEmpresa = ({
  handleStep,
  dataForm,
  setDataForm,
  setMsg,
  setOpenSnackbarErro,
  error,
  setError,
  handleError,
  handleHelperText,
}) => {
  const [mascaraDocumento, setMascaraDocumento] = useState("99.999.999/9999-99");
  const [valid, setValid] = useState({
    documento: true,
    cpf: false,
  });

  const tiposDocumento = ["CNPJ", "RG", "RNE"];

  const handleVerificarDocumento = async (value, type) => {
    const response = await validarFormatacaoDocumento(value, type);

    switch (type) {
      case "CNPJ":        
        if (!response) {
          setValid({
            ...valid,
            documento: false,
          });
          setMsg("CNPJ inválido!");
          setOpenSnackbarErro(true);
        } else {
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "CPF":
        if (!response) {
          setValid({
            ...valid,
            cpf: false,
          });
          setMsg("CPF inválido!");
          setOpenSnackbarErro(true);
        } else {
          setValid({
            ...valid,
            cpf: true,
          });
        }
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setError(false);
  }, []);

  useEffect(() => {
    switch (dataForm?.responsavelEmpresa?.tipoDocumento) {
      case "RG":
        {
          setMascaraDocumento("********************");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "CNPJ":
        {
          setMascaraDocumento("99.999.999/9999-99");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;
      case "RNE":
        {
          setMascaraDocumento("a9999999-a");
          setValid({
            ...valid,
            documento: true,
          });
        }
        break;

      default:
        break;
    }
  }, [dataForm?.responsavelEmpresa?.tipoDocumento]);

  useEffect(() => {
    const cnpj = dataForm?.responsavelEmpresa?.documento;
    const cpf = dataForm?.responsavelEmpresa?.cpf;

    if (dataForm?.responsavelEmpresa?.tipoDocumento === "CNPJ") {
      if (cnpj?.length === 14) {
        handleVerificarDocumento(cnpj, "CNPJ");
      } else {        
        setValid({
          ...valid,
          documento: false,
        });
      }
    } else {
      setValid({
        ...valid,
        documento: true,
      });
    }
    if (cpf?.length === 11) {
      handleVerificarDocumento(cpf, "CPF");
    } else {
      setValid({
        ...valid,
        cpf: false,
      });
    }
  }, [
    dataForm?.responsavelEmpresa?.documento,
    dataForm?.responsavelEmpresa?.cpf,
  ]);

  const handleNext = (e) => {
    e.preventDefault();
    const form = e.target;
    if (
      dataForm?.responsavelEmpresa?.tipoDocumento === "CNPJ" &&
      !valid.documento
    ) {
      setMsg("CNPJ Inválido");
      setOpenSnackbarErro(true);
    }
    if (dataForm?.responsavelEmpresa?.cpf && !valid.cpf) {
      setMsg("CPF Inválido");
      setOpenSnackbarErro(true);
    }

    if (form.checkValidity() && valid.documento && valid.cpf) {
      handleStep(2);
    } else {
      setError(true);
    }
  };

  const handleBack = () => {
    handleStep(0);
  };

  const handleChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    switch (name) {
      case "documento":
        value = value.replace(/[^\w\s]/gi, "");
        break;
      case "cpf":
        value = value.replace(/[^\w\s]/gi, "");
        break;
    }

    setDataForm({
      ...dataForm,
      responsavelEmpresa: { ...dataForm.responsavelEmpresa, [name]: value },
    });
  };

  // const handleChangeAutocomplete = (name, value) => {
  //   setDataForm({
  //     ...dataForm,
  //     responsavelEmpresa: { ...dataForm.responsavelEmpresa, [name]: value },
  //   });
  // };

  return (
    <form onSubmit={handleNext} noValidate>
      <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            size="small"
            label="Nome"
            name="nome"
            fullWidth
            value={dataForm?.responsavelEmpresa?.nome}
            onChange={handleChange}
            error={handleError("responsavelEmpresa", "nome")}
            helperText={handleHelperText("responsavelEmpresa", "nome")}
            required
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <TextField
            size="small"
            label="Profissão"
            name="profissao"
            fullWidth
            value={dataForm?.responsavelEmpresa?.profissao}
            error={handleError("responsavelEmpresa", "profissao")}
            helperText={handleHelperText("responsavelEmpresa", "profissao")}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={5} sm={3} md={2}>
          <FormControl>
            <FormLabel sx={{ fontSize: "Medio" }}>Estrangeiro?</FormLabel>
            <RadioGroup
              value={dataForm?.responsavelEmpresa?.estrangeiro}
              row
              name="estrangeiro"
              onChange={handleChange}
            >
              <FormControlLabel
                value="true"
                control={<Radio sx={{ height: "5px" }} />}
                label="Sim"
              />
              <FormControlLabel
                value="false"
                control={<Radio sx={{ height: "5px" }} />}
                label="Não"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={7} sm={2}>
          <TextField
            size="small"
            label="Tipo Documento"
            name="tipoDocumento"
            fullWidth
            value={dataForm?.responsavelEmpresa?.tipoDocumento  || "CNPJ"}
            onChange={handleChange}
            select
          >
            {tiposDocumento.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <InputMask
            mask={mascaraDocumento}
            maskChar={null}
            onChange={handleChange}
            value={dataForm?.responsavelEmpresa?.documento}
          >
            {() => (
              <TextField
                size="small"
                label="Documento"
                name="documento"
                fullWidth
                error={
                  dataForm?.responsavelEmpresa?.tipoDocumento === "CNPJ" &&
                  !valid.documento
                    ? true
                    : handleError("responsavelEmpresa", "documento")
                }
                helperText={handleHelperText("responsavelEmpresa", "documento")}
                color={
                  dataForm?.responsavelEmpresa?.tipoDocumento === "CNPJ" &&
                  !valid.documento
                    ? "error"
                    : ""
                }
                required
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={2}>
          <InputMask
            mask={"999.999.999-99"}
            maskChar={null}
            onChange={handleChange}
            value={dataForm?.responsavelEmpresa?.cpf}
          >
            {() => (
              <TextField
                size="small"
                label="CPF"
                name="cpf"
                fullWidth
                error={
                  dataForm?.responsavelEmpresa?.cpf && !valid.cpf
                    ? true
                    : handleError("responsavelEmpresa", "cpf")
                }
                helperText={handleHelperText("responsavelEmpresa", "cpf")}
                color={valid.cpf ? "success" : ""}
                required
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={5} md={3}>
          <TextField
            value={dataForm?.responsavelEmpresa?.ramo}
            size="small"
            label="Ramo de atividade"
            name="ramo"
            fullWidth
            onChange={handleChange}
            error={handleError("responsavelEmpresa", "ramo")}
            helperText={handleHelperText("responsavelEmpresa", "ramo")}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6} md={5}>
          <TextField
            value={dataForm?.responsavelEmpresa?.email}
            size="small"
            label="E-mail"
            name="email"
            onChange={handleChange}
            fullWidth
            error={handleError("responsavelEmpresa", "email")}
            helperText={handleHelperText("responsavelEmpresa", "email")}
            required
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <InputMask
            mask="OAB999999/TT"
            maskChar={null}
            formatChars={{
              9: "[0-9]",
              T: "[A-Z]",
            }}
            value={dataForm?.responsavelEmpresa?.oab}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="NºOAB"
                name="oab"
                fullWidth
                placeholder="OAB123456/SP"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <InputMask
            mask="AA999999/O-9"
            maskChar={null}
            formatChars={{
              9: "[0-9]",
              A: "[A-Z]",
              O: "[OPT]",
            }}
            value={dataForm?.responsavelEmpresa?.crc}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="NºCRC"
                name="crc"
                fullWidth
                placeholder="SP123456/O-1"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            mask="(99) 9999 9999"
            maskChar={null}
            value={dataForm?.responsavelEmpresa?.telefone}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="Telefone"
                name="telefone"
                fullWidth
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputMask
            mask="(99) 9 9999 9999"
            maskChar={null}
            value={dataForm?.responsavelEmpresa?.whatsapp}
            onChange={handleChange}
          >
            {() => (
              <TextField
                size="small"
                label="WhatsApp"
                name="whatsapp"
                fullWidth
                error={handleError("responsavelEmpresa", "whatsapp")}
                helperText={handleHelperText("responsavelEmpresa", "whatsapp")}
                required
              />
            )}
          </InputMask>
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <FormControl>
            <FormLabel sx={{ fontSize: "medio" }}>Alguém te indicou?</FormLabel>
            <RadioGroup
              value={dataForm?.responsavelEmpresa?.foiIndicado}
              row
              name="foiIndicado"
              onChange={handleChange}
            >
              <FormControlLabel
                value="true"
                control={<Radio sx={{ height: "5px" }} />}
                label="Sim"
              />
              <FormControlLabel
                value="false"
                control={<Radio sx={{ height: "5px" }} />}
                label="Não"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        {dataForm?.responsavelEmpresa?.foiIndicado === "true" ? (
          <Grid item xs={6} sm={2}>
            <TextField
              size="small"
              label="Indicado Por..."
              fullWidth
              name="indicadoPor"
              value={dataForm?.responsavelEmpresa?.indicadoPor}
              onChange={handleChange}
            />
          </Grid>
        ) : (
          ""
        )}
      </Grid>

      <div className={styles.container_button}>
        <Button className={styles.button_back} onClick={handleBack}>
          Voltar
        </Button>
        <Button className={styles.button_next} type="submit">
          Avançar
        </Button>
      </div>
    </form>
  );
};

export default ResponsavelEmpresa;
